import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'; // Add this to your imports
import { UpdateUserLevel, GetById } from '../../service/UserLevelService';

export default function UpdateStatusUserLevel() {
  const {
    isLoading,
    setIsLoading,
    isAppError,
    setAppError,
    appErrorMessage,
    setAppErrorMessage,
    appErrorTitle,
    setAppErrorTitle,
    appErrorMode,
    setAppErrorMode,
    appUser
  } = useGlobalContext();

  //read id from useParams
  const { id } = useParams();

  const [userLevel, setUserLevel] = useState({});

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [giftName, setGiftName] = useState('');
  const [remarks, setRemarks] = useState('');
  const [givenDate, setGivenDate] = useState('');


  const fetchUserLevelById = async () => {
    try {
      setIsLoading(true);
      var response = await GetById(id);
      if (response.status === 200) {
        setUserLevel(response.userLevel);
        setName(response.userLevel.user.name);
        setEmail(response.userLevel.user.email);
        setMobile(response.userLevel.user.mobile);
        setGiftName(response.userLevel.giftActual.name);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  const saveMember = async (event) => {
    event.preventDefault();

    if (remarks.length < 3) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Remarks must be at least 3 characters");
      setAppErrorMode("error");
      return;
    }

    // Validate givenDate
    if (!givenDate) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Given date is required");
      setAppErrorMode("error");
      return;
    }   

    setIsLoading(true);

    try {
      const response = await UpdateUserLevel(id, remarks, givenDate);
      console.log("users", response);
      if (response.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(response.message || "User Level Successfully Updated");
        setAppErrorMode("success");
        window.location.href = "/reports/level";
      }
      else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(response.message || "Failed to update user level. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to update member. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    if (id != null && id != undefined && id != "") {
      fetchUserLevelById();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Update Member Level Manage | {config.appName}</title>
      </Helmet>

      <div className="container">
        <div className="page">
          <div className="page-heading">
            <h1>Update Member Level</h1>
            <span>
              <Link to="/"> Dashboard </Link> / <Link to="/reports/level"> Level Report </Link> / Member Manage
            </span>
          </div>

          <div className="page-content">
            <div className="portal">
              <div className="portal-body">
                <form onSubmit={saveMember} encType='multipart/form-data'>
                  <div className="row">

                    <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input
                          className='form-control'
                          type='text'
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          disabled />
                      </div>
                    </div>
                    <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Mobile</label>
                        <input
                          className='form-control'
                          type='number'
                          value={mobile}
                          onChange={(e) => setMobile(e.target.value)}
                          disabled />
                      </div>
                    </div>

                    <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          className='form-control'
                          type='email'
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          disabled />
                      </div>
                    </div>

                    <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Gift</label>
                        <input
                          className='form-control'
                          type='text'
                          value={giftName}
                          onChange={(e) => setGiftName(e.target.value)}
                          disabled />
                      </div>
                    </div>
                    <div className='col-lg-8 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Remarks</label>
                        <input
                          className='form-control'
                          type='text'
                          value={remarks}
                          onChange={(e) => setRemarks(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Given Date</label>
                        <input
                          className='form-control'
                          type='date'
                          value={givenDate}
                          onChange={(e) => setGivenDate(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className='clearfix'></div>
                    <div className='col-12 text-end'>
                      <div className="mb-3">
                        <button type='reset' className='btn btn-danger btn-md'>
                          <i className="ri-reset-right-line"></i> Reset
                        </button>
                        &nbsp;&nbsp;
                        <button type='submit' className='btn btn-success btn-md'>
                          <i className="ri-check-fill"></i> Update Member Level
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};